module.exports = __webpack_public_path__ + "img/shape_hearth--black.3daf0e5.png";